import { render, staticRenderFns } from "./TheHeaderLocale.vue?vue&type=template&id=4c33acee&scoped=true&"
import script from "./TheHeaderLocale.vue?vue&type=script&lang=js&"
export * from "./TheHeaderLocale.vue?vue&type=script&lang=js&"
import style0 from "./TheHeaderLocale.vue?vue&type=style&index=0&id=4c33acee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c33acee",
  null
  
)

export default component.exports